/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeactivateUserDialogFragment = {
  readonly __typename: "User";
  readonly id: c.UserId;
  readonly name: string | null;
  readonly email: string;
  readonly numberOfOwnedProjects: number;
};

export type UserToTranferToQueryVariables = Types.Exact<{
  userId: Types.Scalars["UserId"]["input"];
}>;

export type UserToTranferToQuery = {
  readonly __typename: "Query";
  readonly userById: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
    readonly imageUrl: string | null;
    readonly orgRole: Types.OrgRole;
  };
};

export const DeactivateUserDialogFragmentDoc = /*#__PURE__*/ gql`
  fragment DeactivateUserDialogFragment on User {
    id
    name
    email
    numberOfOwnedProjects
  }
`;
export const UserToTranferToDocument = /*#__PURE__*/ gql`
  query UserToTranferTo($userId: UserId!) {
    userById(userId: $userId) {
      id
      name
      email
      imageUrl
      orgRole
    }
  }
`;

/**
 * __useUserToTranferToQuery__
 *
 * To run a query within a React component, call `useUserToTranferToQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserToTranferToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserToTranferToQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserToTranferToQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserToTranferToQuery,
    UserToTranferToQueryVariables
  > &
    (
      | { variables: UserToTranferToQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserToTranferToQuery, UserToTranferToQueryVariables>(
    UserToTranferToDocument,
    options,
  );
}
export function useUserToTranferToLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserToTranferToQuery,
    UserToTranferToQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserToTranferToQuery,
    UserToTranferToQueryVariables
  >(UserToTranferToDocument, options);
}
export function useUserToTranferToSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserToTranferToQuery,
    UserToTranferToQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserToTranferToQuery,
    UserToTranferToQueryVariables
  >(UserToTranferToDocument, options);
}
export type UserToTranferToQueryHookResult = ReturnType<
  typeof useUserToTranferToQuery
>;
export type UserToTranferToLazyQueryHookResult = ReturnType<
  typeof useUserToTranferToLazyQuery
>;
export type UserToTranferToSuspenseQueryHookResult = ReturnType<
  typeof useUserToTranferToSuspenseQuery
>;
export type UserToTranferToQueryResult = Apollo.QueryResult<
  UserToTranferToQuery,
  UserToTranferToQueryVariables
>;
